import {
  REACT_APP_HOTEL_BASE_URL,
  REACT_APP_SNAP_BASE_URL,
  REACT_APP_ENVIRONMENT,
  REACT_APP_METADATA_BASE_URL,
  REACT_APP_HOTEL_SA_CLIENT_ID,
  REACT_APP_HOTELS_BASE_URL,
  REACT_APP_SNAP_HOME_URL,
  REACT_APP_SNAP_DOMAIN_ID,
  REACT_APP_HOTEL_SSR_URL,
  REACT_APP_HOTEL_HOME_URL,
  REACT_APP_KONG_API_GATEWAY,
  REACT_APP_COUNTRY_CODE_ENDPOINT,
  REACT_APP_UHF_ENV,
  REACT_APP_SSO_BASE_URL,
  REACT_APP_SSO_ORIGIN,
  REACT_APP_GOOGLE_API_KEY,
  REACT_APP_REVERSE_GEO_LOCATION_URL,
  REACT_APP_ANDROID_BUILD_IMAGE_PATH,
  REACT_APP_GA_CLIENT_ID,
  REACT_APP_TRIP_ADVISOR_BASE_URL,
  REACT_APP_TRIP_ADVISOR_API_KEY,
  REACT_APP_PAYMENT_KONG_API_GATEWAY,
  REACT_APP_FLIGHT_SSR_TRANSLATIONS,
  REACT_APP_CHECKIN_DEEPLINK_ENCRYPT,
  REACT_APP_NEW_METADATA_BASE_URL,
  REACT_APP_STATIC_FLIGHT_BASE_URL,
  REACT_APP_STATIC_COSMOS_BASE_URL,
  REACT_APP_SUGGESTION_URL,
  REACT_APP_SUGGESTION_URL_V2,
  REACT_APP_STATIC_FAVOURITE_BASE_URL,
  REACT_APP_OTA_FLIGHTS_API,
  REACT_APP_FLIGHTS_ZODIAC_KEY,
  REACT_APP_USER_SUBSCRIPTION_URL,
} from 'react-native-dotenv';

const setupConfig = {
  REACT_APP_HOTEL_BASE_URL,
  REACT_APP_SNAP_BASE_URL,
  REACT_APP_ENVIRONMENT,
  REACT_APP_METADATA_BASE_URL,
  REACT_APP_HOTEL_SA_CLIENT_ID,
  REACT_APP_HOTELS_BASE_URL,
  REACT_APP_SNAP_HOME_URL,
  REACT_APP_SNAP_DOMAIN_ID,
  REACT_APP_HOTEL_SSR_URL,
  REACT_APP_HOTEL_HOME_URL,
  REACT_APP_KONG_API_GATEWAY,
  REACT_APP_COUNTRY_CODE_ENDPOINT,
  REACT_APP_UHF_ENV,
  REACT_APP_SSO_BASE_URL,
  REACT_APP_SSO_ORIGIN,
  REACT_APP_GOOGLE_API_KEY,
  REACT_APP_REVERSE_GEO_LOCATION_URL,
  REACT_APP_ANDROID_BUILD_IMAGE_PATH,
  REACT_APP_GA_CLIENT_ID,
  REACT_APP_TRIP_ADVISOR_BASE_URL,
  REACT_APP_TRIP_ADVISOR_API_KEY,
  REACT_APP_PAYMENT_KONG_API_GATEWAY,
  REACT_APP_FLIGHT_SSR_TRANSLATIONS,
  REACT_APP_CHECKIN_DEEPLINK_ENCRYPT,
  REACT_APP_NEW_METADATA_BASE_URL,
  REACT_APP_STATIC_FLIGHT_BASE_URL,
  REACT_APP_STATIC_COSMOS_BASE_URL,
  REACT_APP_SUGGESTION_URL,
  REACT_APP_SUGGESTION_URL_V2,
  REACT_APP_STATIC_FAVOURITE_BASE_URL,
  REACT_APP_OTA_FLIGHTS_API,
  REACT_APP_FLIGHTS_ZODIAC_KEY,
  REACT_APP_USER_SUBSCRIPTION_URL,
};

let config = {};

if (typeof navigator != 'undefined' && navigator.product === 'ReactNative') {
  config = setupConfig;
} else {
  Object.keys(setupConfig).forEach(key => {
    config[key] = process.env[key];
  });
}

export default config;
